import script from "./Veranstaltungen.vue?vue&type=script&setup=true&lang=js"
export * from "./Veranstaltungen.vue?vue&type=script&setup=true&lang=js"

import "./Veranstaltungen.vue?vue&type=style&index=0&id=40b9bad3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40b9bad3"]])

export default __exports__